module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n    默认首页设置\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "large-add-button"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Add
    }
  }, [_c('span'), _vm._v("\n      + 添加绑定\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('aside'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "contentBox"
    }
  }, [_c('div', {
    staticClass: "mui-content"
  }, [_c('div', {
    staticClass: "common-list-box form-group"
  }, _vm._l((_vm.nameList), function(item, index) {
    return _c('div', {
      staticClass: "form-group-item"
    }, [_c('span', {
      staticClass: "form-label"
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "form-content verify-method  text-right"
    }, [_c('a', {
      staticClass: "right-del up-move-icon act-icon",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.IndexUp(index)
        }
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "right-del down-move-icon act-icon",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.IndexDown(index)
        }
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "right-del del-icon act-icon",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.IndexDel(index)
        }
      }
    })])])
  })), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": "0.2rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("确定")])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('div', {
    staticClass: "alert-warn margin-bottom-20 domain-list"
  }, [_c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("默认首页，即访问您的网站时的默认首页")]), _vm._v(" "), _c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("为了提高访问速度，建议您将有效的首页设为高优先级")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16a21140","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/hostoperate/defaultset.vue
// module id = aDlo
// module chunks = 1